let General = {
    init: function () {
        document.addEventListener('click', function (event) {
            if (event.target.matches('.scroll-link')) {
                event.preventDefault();

                let target = document.getElementById(event.target.dataset.target);

                General.scrollTo(target);
            }
        });
    },

    scrollTo: function(target) {
        let bodyRect = document.body.getBoundingClientRect();
        let rect = target.getBoundingClientRect();

        setTimeout(function() {
            General.scrollIt(rect.top - bodyRect.top);
        }, 25);
    },

    showErrors: function(errors) {
        Object.keys(errors).forEach(function(field){
            document.getElementById('error_' + field).innerText = errors[field];
            document.getElementById('error_' + field).style.display = 'block';
        });

        var bodyRect = document.body.getBoundingClientRect();
        var rect = document.querySelector('.error-form').getBoundingClientRect();

        setTimeout(function() {
            General.scrollIt(rect.top - bodyRect.top);
        }, 100);
    },

    hideErrors: function() {
        var errors = document.querySelectorAll('form .error-form');
        errors.forEach(function(error) {
            error.style.display = 'none';
        });
    },

    scrollIt: function(newTop, correction) {
        var correctionValue = 0;
        if (correction || correction === undefined) {
            correctionValue = 200;
        }
        newTop -= correctionValue;

        window.scrollTo({
            'behavior': 'smooth',
            'left': 0,
            'top': newTop
        });
    }
};
General.init();
window.General = General;

window.onload = function () {
    // Navbar hide-reveal logic
    let stickyNavBar = document.getElementById("sticky-nav-bar");
    let prevScrollpos = window.pageYOffset;
    let prevStickyNavBarClasses = stickyNavBar.className;
    const hideRevealNavbar = () => {
        let currentScrollPos = window.pageYOffset;
        if (window.pageYOffset > 0) {
            if (prevScrollpos > currentScrollPos) {
                stickyNavBar.classList.remove("-translate-y-full");
            } else {
                stickyNavBar.classList.add("-translate-y-full");
            }
        } else {
            stickyNavBar.setAttribute('class', prevStickyNavBarClasses);
        }
        prevScrollpos = currentScrollPos;
    };
    window.onscroll = hideRevealNavbar;
};
